// extracted by mini-css-extract-plugin
module.exports = {"noComments":"I5agb","noCommentsText":"I5agd","noCommentsSubText":"I5agf"};